{
  "en": {
    "modelPicker": {
      "hangarTitle": "Add Ships to your Hangar",
      "compareTitle": "Select Ships to Compare",
      "cargoGridsTitle": "Select Ships for the Cargo Grid",
      "tradeRoutesTitle": "Select a Ship to Rank Trade Routes For",
      "wishlistTitle": "Add Ships to your Wishlist",
      "labels": {
        "search": "Search by name or manufacturer",
        "hangarOnly": "Only my Ships",
        "containerFit": "Load to carry",
        "results": "%{count} Ships",
        "selected": "%{count} Selected"
      },
      "actions": {
        "resetFilters": "Reset Filters",
        "moreFilters": "More Filters",
        "clearSelection": "Clear Selection",
        "increase": "Add another %{name}",
        "decrease": "Remove one %{name}"
      },
      "badges": {
        "inHangar": "In Hangar",
        "onWishlist": "On Wishlist",
        "comparing": "Comparing",
        "onCargoGrid": "On the Grid"
      }
    }
  }
}
